import { render, staticRenderFns } from "./Mint.vue?vue&type=template&id=228af8cc"
import script from "./Mint.vue?vue&type=script&lang=js"
export * from "./Mint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports